const utils ={
    formatPrice:(intPrice, strCurrency = 'USD') =>{
      const formatter = new Intl.NumberFormat(navigator.language, {
          style: 'currency',
          currency: strCurrency
      });
      return formatter.format(intPrice);
    },
    guid:() =>{
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
            var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });  
    },
    getFontFamilies:() =>{
        const fontCheck = new Set([
            // Windows 10
            'Arial', 'Arial Black', 'Bahnschrift', 'Calibri', 'Cambria', 'Cambria Math', 'Candara', 'Comic Sans MS', 'Consolas', 'Constantia', 'Corbel', 'Courier New', 'Ebrima', 'Franklin Gothic Medium', 'Gabriola', 'Gadugi', 'Georgia', 'HoloLens MDL2 Assets', 'Impact', 'Ink Free', 'Javanese Text', 'Leelawadee UI', 'Lucida Console', 'Lucida Sans Unicode', 'Malgun Gothic', 'Marlett', 'Microsoft Himalaya', 'Microsoft JhengHei', 'Microsoft New Tai Lue', 'Microsoft PhagsPa', 'Microsoft Sans Serif', 'Microsoft Tai Le', 'Microsoft YaHei', 'Microsoft Yi Baiti', 'MingLiU-ExtB', 'Mongolian Baiti', 'MS Gothic', 'MV Boli', 'Myanmar Text', 'Nirmala UI', 'Palatino Linotype', 'Segoe MDL2 Assets', 'Segoe Print', 'Segoe Script', 'Segoe UI', 'Segoe UI Historic', 'Segoe UI Emoji', 'Segoe UI Symbol', 'SimSun', 'Sitka', 'Sylfaen', 'Symbol', 'Tahoma', 'Times New Roman', 'Trebuchet MS', 'Verdana', 'Webdings', 'Wingdings', 'Yu Gothic',
            // macOS
            'American Typewriter', 'Andale Mono', 'Arial', 'Arial Black', 'Arial Narrow', 'Arial Rounded MT Bold', 'Arial Unicode MS', 'Avenir', 'Avenir Next', 'Avenir Next Condensed', 'Baskerville', 'Big Caslon', 'Bodoni 72', 'Bodoni 72 Oldstyle', 'Bodoni 72 Smallcaps', 'Bradley Hand', 'Brush Script MT', 'Chalkboard', 'Chalkboard SE', 'Chalkduster', 'Charter', 'Cochin', 'Comic Sans MS', 'Copperplate', 'Courier', 'Courier New', 'Didot', 'DIN Alternate', 'DIN Condensed', 'Futura', 'Geneva', 'Georgia', 'Gill Sans', 'Helvetica', 'Helvetica Neue', 'Herculanum', 'Hoefler Text', 'Impact', 'Lucida Grande', 'Luminari', 'Marker Felt', 'Menlo', 'Microsoft Sans Serif', 'Monaco', 'Noteworthy', 'Optima', 'Palatino', 'Papyrus', 'Phosphate', 'Rockwell', 'Savoye LET', 'SignPainter', 'Skia', 'Snell Roundhand', 'Tahoma', 'Times', 'Times New Roman', 'Trattatello', 'Trebuchet MS', 'Verdana', 'Zapfino',
        ].sort());

        const fontAvailable = new Set();

        for ( const font of fontCheck.values() ) {
            if ( document.fonts.check( `12px "${ font }"` ) ) {
                fontAvailable.add( font );
            }
        }
        return [...fontAvailable.values()];
    },
    randomInt: (min, max) =>{
        return Math.floor(Math.random() * (max - min + 1) + min)  
    },
    createVariantCombinations: (products) =>{
        let allVariantGroups = {};
        let variantCombinations = {};
        products.forEach((product) =>{
            allVariantGroups[product.type] = {};
            variantCombinations[product.type] = {};
            Object.keys(product.variantGroups).forEach((key) =>{
                allVariantGroups[product.type][key] = product.variantGroups[key].options.map(a => a.id);
            });
            variantCombinations[product.type] = [];
            for (let i = 0; i < allVariantGroups[product.type].colors.length; i++) {
                for (let j = 0; j < allVariantGroups[product.type].sizes.length; j++) {
                    if(utils.randomInt(0, allVariantGroups[product.type].sizes.length) === j){
                        continue;
                    }
                    const variantId = allVariantGroups[product.type].colors[i] + "." + allVariantGroups[product.type].sizes[j];
                    const colorEntry = product.variantGroups.colors.options.find( vo => vo.id === allVariantGroups[product.type].colors[i]);
                    const sizeEntry = product.variantGroups.sizes.options.find( vo => vo.id === allVariantGroups[product.type].sizes[j]);
                    const name = product.name;
                    const price = colorEntry.price || sizeEntry.price || product.price || 200;
                    const isDefault = variantId === product.variantId;
                    variantCombinations[product.type].push({ variantId, name, price, isDefault });
                }
            }
        });
        return variantCombinations;
    }
};

export {utils};